<template>
  <div>
    <el-select
     :placeholder="$t('Seçin')" 
     filterable :value="selected"
      @input="handleInput" 
      style="width: 100%">
      <el-option 
      v-for="(item,index) in data" 
      :key="`bank-${item.bankId}-${index}`" 
      :label="item.bankName" 
      :value="item.bankId">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { GetBanks } from "../../services/cls";
export default {
  props: {
    value: [Number, String],
  },
  data() {
    return {
      data: [],
      selected: this.value,
    };
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e);
      this.selected = e;
    },

    getData() {
      GetBanks().then((response) => {
        if (response.data.data) {
          this.data = response.data.data;
        } else {
          this.$message({
            type: "error",
            message: "Banks: No data found!",
          });
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    value() {
      this.selected = this.value;
    },
  },
};
</script>

<style lang="scss" scoped></style>